import GoglobalAuth from "./GoglobalAuth";
import serviceAccount from "./keyService.json";

const Auth = new GoglobalAuth();

Auth.createApp(serviceAccount.app_id, serviceAccount.key, serviceAccount.url);
export default Auth;
